export function Separator({ className = "" }) { return <div className={`mc-sep ${className}`} />; }
